import { subYears, getYear } from 'date-fns';

export function getLastYears(count: number): string[] {
  const lastYear = getYear(subYears(new Date(), 1));
  return Array.from({ length: count }, (_, i) => String(lastYear - i));
}
